export const SETTINGS_CONFIG = {
  audio: {
    label: 'Audio Settings',
    settings: [
      {
        id: 'masterVolume',
        label: 'Master Volume',
        type: 'slider',
        value: 100,
        min: 0,
        max: 100
      },
      {
        id: 'musicVolume',
        label: 'Music Volume',
        type: 'slider',
        value: 80,
        min: 0,
        max: 100
      },
      {
        id: 'sfxVolume',
        label: 'Sound Effects',
        type: 'slider',
        value: 90,
        min: 0,
        max: 100
      }
    ]
  },
  notifications: {
    label: 'Notifications',
    settings: [
      {
        id: 'pushNotifications',
        label: 'Push Notifications',
        type: 'toggle',
        value: true
      },
      {
        id: 'inGameNotifications',
        label: 'In-Game Notifications',
        type: 'toggle',
        value: true
      },
      {
        id: 'eventReminders',
        label: 'Event Reminders',
        type: 'toggle',
        value: true
      }
    ]
  },
  graphics: {
    label: 'Graphics',
    settings: [
      {
        id: 'quality',
        label: 'Graphics Quality',
        type: 'select',
        value: 'high',
        options: ['low', 'medium', 'high']
      },
      {
        id: 'particles',
        label: 'Particle Effects',
        type: 'toggle',
        value: true
      }
    ]
  },
  privacy: {
    label: 'Privacy & Data',
    settings: [
      {
        id: 'shareGameplay',
        label: 'Share Gameplay Data',
        type: 'toggle',
        value: true
      },
      {
        id: 'shareDiagnostics',
        label: 'Share Diagnostics',
        type: 'toggle',
        value: true
      }
    ]
  }
};
